'use client';

import { motion } from 'motion/react';

export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-[#0a0a0a] py-32 px-6 md:px-12 lg:px-24">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#b4ff00]/5" />
      
      <div className="relative z-10 mx-auto max-w-4xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 text-5xl font-black tracking-tighter text-white md:text-7xl"
        >
          READY TO <span className="text-[#b4ff00]">EVOLVE</span> YOUR <br /> LEAGUE?
        </motion.h2>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mx-auto mb-12 max-w-2xl text-lg text-zinc-400"
        >
          Join over 1400+ global organizations building the future of <span className="text-[#b4ff00]">E-SPORTS</span> technology on Disporty.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-col items-center justify-center gap-4 sm:flex-row"
        >
          <button className="w-full rounded-sm bg-[#b4ff00] px-8 py-4 text-sm font-bold text-black transition-transform hover:scale-105 sm:w-auto">
            REQUEST ACCESS
          </button>
          <button className="w-full rounded-sm border border-zinc-700 bg-zinc-900 px-8 py-4 text-sm font-bold text-white transition-colors hover:bg-zinc-800 sm:w-auto">
            CONTACT SALES
          </button>
        </motion.div>
      </div>
    </section>
  );
}
